import { colors } from '@ovpn-ui/styles';
const lightTheme = {
  itemActiveColor: colors.neutralBgHover,
  itemActiveHoverColor: colors.neutralLight,
  itemHoverColor: colors.neutralBg,
  itemDivider: colors.neutralTextSubtitle,
  bg: colors.neutralOffwhite,
  border: colors.neutralLight,
  text: colors.neutralTextBody,
  flyoutBg: colors.neutralOffwhite,
  flyoutSubItemBg: colors.neutralOffwhite,
  flyoutSubItemHover: colors.neutralBg
};
const darkTheme = {
  itemActiveColor: colors.brandBlueHover,
  itemActiveHoverColor: colors.brandBlue,
  itemHoverColor: colors.brandBlue,
  bg: colors.brandBlueActive,
  border: colors.neutralTextSubtitle,
  text: colors.neutralBg,
  flyoutBg: colors.brandBlueActive,
  flyoutSubItemBg: colors.brandBlueActive,
  flyoutSubItemHover: colors.brandBlue
};
export { lightTheme, darkTheme };